<template>
  <div class="yxtbiz-flip-leave-audit">
    <yxt-row class="yxtbiz-flip-leave-audit__row" align="middle" type="flex">
      <div class="color-gray-7 yxtbiz-flip-leave-audit__name">{{$t('pc_biz_o2o_lbl_face_name' /* 面授名称 */) + $t('pc_biz_enroll_lbl_colon' /* : */)}}</div>
      <div class="yxtbiz-flip-leave-audit__value color-gray-10">{{flipName}}</div>
    </yxt-row>
    <yxt-row class="yxtbiz-flip-leave-audit__row" align="middle" type="flex">
      <div class="color-gray-7 yxtbiz-flip-leave-audit__name">{{$t('pc_biz_scene_name' /* 场次名称 */) + $t('pc_biz_enroll_lbl_colon' /* : */)}}</div>
      <div class="yxtbiz-flip-leave-audit__value color-gray-10">{{sceneName}}</div>
    </yxt-row>
    <yxt-row class="yxtbiz-flip-leave-audit__row" align="middle" type="flex">
      <div class="color-gray-7 yxtbiz-flip-leave-audit__name">{{$t('pc_biz_leave_reason' /* 请假原因 */) + $t('pc_biz_enroll_lbl_colon' /* : */)}}</div>
      <div class="yxtbiz-flip-leave-audit__value color-gray-10">{{leaveReason ? leaveReason : '--'}}</div>
    </yxt-row >
    <yxt-image
      v-if="attachments && attachments.length > 0"
      class="yxtbiz-flip-leave-audit__image"
      :src="attachments[0].url"
      :preview-src-list="[attachments[0].url]"
    />
  </div>
</template>

<script>
import {getLeaveAuditInfo} from './service';

export default {
  name: 'YxtbizFlipLeaveAudit',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      leaveReason: '',
      flipName: '',
      sceneName: '',
      attachments: []
    };
  },
  mounted() {
    this.fetchLeaveAuditInfo();
  },
  methods: {
    fetchLeaveAuditInfo() {
      this.loading = true;
      getLeaveAuditInfo(this.id)
        .then(res => {
          const {attachments, attendName, flipName, sceneName, leaveReason} = res || {};
          Object.assign(this, {attachments, attendName, flipName, sceneName, leaveReason});
        })
        .finally(() =>(this.loading = false));
    }
  }
};
</script>
<style lang="scss" scoped>
.yxtbiz-flip-leave-audit {
  &__row:not(:first-child) {
    margin-top: 24px;
  }

  &__name {
    line-height: 22px;
    font-size: 14px;    
  }

  &__label {
    line-height: 22px;
    font-size: 14px;
  }

  &__image {
    margin-top: 10px;
    width: 120px;
    height: 120px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
  }
}
</style>